import "./App.css";
import AppRoutes from "./AppRoutes";
import { ErrorBoundary } from "react-error-boundary";
import InternalServer from "./Pages/Others/InternalServer";
import FormDataContext, { FormDataContextProvider } from "./Contexts/FormData.context";
import SignupDataContext, { UserDataContextProvider } from "./Contexts/User.context";
import { BillingDataContextProvider } from "./Contexts/Billing.Context";
import { getVisitorServiceUrl } from "./Services/base-url/api-constants";
import { Helmet } from "react-helmet";
import $ from "jquery";

function App() {
  const url = getVisitorServiceUrl("");
  window.$ = $;
  window.jQuery = $;
  return (
    <ErrorBoundary
      FallbackComponent={InternalServer}
      onError={(error, errorInfo) => ({ error, errorInfo })}
      onReset={() => {
        // reset the state of your app
      }}
    >
      <Helmet>
        <script src={url} type="text/javascript" />
      </Helmet>
      <UserDataContextProvider>
        <FormDataContextProvider>
          <BillingDataContextProvider>
            <AppRoutes />
          </BillingDataContextProvider>
        </FormDataContextProvider>
      </UserDataContextProvider>

      {/* <SignupDataContextProvider>
            <SignupDataContext.Consumer>{(context) => <AppRoutes />}</SignupDataContext.Consumer>
            </SignupDataContextProvider> */}
    </ErrorBoundary>
  );
}

export default App;
